import { useState } from "react";
import { SERVICES } from "@/data/services";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const ContactSection = () => {
  const [contact, setContact] = useState({ name: "", email: "", phone: "", service_interest: "", message: "" });
  const [contactLoading, setContactLoading] = useState(false);

  const field = "w-full bg-brand-card border border-gray-300 rounded-sm px-4 py-3 text-sm text-brand-dark placeholder:text-gray-400 focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors";

  const submitContact = async (e) => {
    e.preventDefault();
    setContactLoading(true);
    try {
      await api.post("/contact", contact);
      window.gtag?.("event", "generate_lead", {
        form_name: "contact",
        service_interest: contact.service_interest || "none",
        page_path: window.location.pathname,
      });
      toast.success("Request received! Our team will contact you shortly.");
      setContact({ name: "", email: "", phone: "", service_interest: "", message: "" });
    } catch (err) {
      toast.error("Could not send request. Please try again.");
    } finally {
      setContactLoading(false);
    }
  };

  return (
    <section id="contact" className="max-w-7xl mx-auto px-5 sm:px-8 py-28 grid lg:grid-cols-2 gap-16">
      <div>
        <p className="text-sm tracking-[0.2em] uppercase font-semibold text-brand-dark mb-3">Get in touch</p>
        <h2 className="text-3xl sm:text-4xl font-heading font-extrabold tracking-tight mb-6 text-brand-dark">
          Request a service or a free consultation.
        </h2>
        <p className="text-gray-600 font-medium leading-relaxed mb-8">
          Tell us what you need. Our team reviews every request and responds within 24 hours to scope your
          project and guide you through payment.
        </p>
        <img src={SERVICES[0].image} alt="" className="rounded-lg border border-gray-200 shadow-lg w-full h-64 object-cover" />
      </div>
      <form onSubmit={submitContact} className="rounded-lg bg-brand-card border border-gray-200 shadow-sm p-8 space-y-4" data-testid="contact-form">
        <input data-testid="contact-name" required placeholder="Full name" className={field}
          value={contact.name} onChange={(e) => setContact({ ...contact, name: e.target.value })} />
        <div className="grid sm:grid-cols-2 gap-4">
          <input data-testid="contact-email" required type="email" placeholder="Email" className={field}
            value={contact.email} onChange={(e) => setContact({ ...contact, email: e.target.value })} />
          <input data-testid="contact-phone" required placeholder="Phone" className={field}
            value={contact.phone} onChange={(e) => setContact({ ...contact, phone: e.target.value })} />
        </div>
        <select data-testid="contact-service" className={field}
          value={contact.service_interest} onChange={(e) => setContact({ ...contact, service_interest: e.target.value })}>
          <option value="">Service of interest (optional)</option>
          {SERVICES.map((s) => <option key={s.id} value={s.name}>{s.name}</option>)}
        </select>
        <textarea data-testid="contact-message" required rows={4} placeholder="How can we help?" className={field}
          value={contact.message} onChange={(e) => setContact({ ...contact, message: e.target.value })} />
        <Button data-testid="contact-submit" type="submit" disabled={contactLoading}
          className="w-full bg-brand-yellow hover:bg-brand-yellowhover text-brand-dark font-semibold rounded-sm py-6 text-base">
          {contactLoading ? "Sending..." : "Send Request"}
        </Button>
      </form>
    </section>
  );
};
